function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 0.0390625C8.97602 0.0390625 0.0390625 8.97602 0.0390625 20C0.0390625 31.024 8.97602 39.9609 20 39.9609C31.024 39.9609 39.9609 31.024 39.9609 20C39.9609 8.97602 31.024 0.0390625 20 0.0390625ZM20.7271 30.4038C20.7271 30.4038 20.337 30.7836 19.9867 30.7836C19.6365 30.7836 19.2661 30.3963 19.2661 30.3963C13.7077 25.1894 8.35617 22.0198 8.35617 16.8119C8.35617 12.9041 11.2671 10.0195 14.1781 10.0195C19.0297 10.0195 20.0001 12.9305 20.0001 12.9305C20.0001 12.9305 20.9705 10.0195 25.8207 10.0195C28.733 10.0195 31.644 12.9428 31.644 16.8119C31.6439 22.0286 26.2963 25.1868 20.7271 30.4038Z",
  fill: "white"
});

var SvgHeartIcon = function SvgHeartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    style: {
      position: "static !important"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "assets/heart-icon.1b8cd334.svg";
export { SvgHeartIcon as ReactComponent };